
import { computed, defineComponent, Ref, toRef } from 'vue';
function useGetLength(age: Ref) {
    return computed(() => {
        return age.value.toString().length
    })
}
export default defineComponent({
    name: 'App',
    props: {
        age: {
            type: Number,
            require: true,
        }
    },
    setup(props) {
        const length = useGetLength(toRef(props,'age'));
        return {
            length,
        }
    }
});
